<template>
    <section
        class="hero section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <c-modal style="position: fixed; height: 100%; width: 100%;" id="email-modal" :active.sync="emailModalActive">
            <div class="center-content">
                <h3 class="mt-0 mb-12">Start your trial</h3>
                <p class="text-sm mb-32">
                    Enter your email address to download Pixtel and start your free trial.
                </p>
            </div>
            <div class="mb-16 mx-8">
                <c-input
                    v-bind:key="emailModalActive"
                    @enter="onEnter"
                    class="download-email"
                    id="email"
                    type="email"
                    label="Email address"
                    placeholder="Work email"
                    form-group="desktop"
                    label-hidden
                    v-model="emailAddress"
                    :status="status ? status : ''"
                    :hint="hint ? hint : ' '">
                    <c-button @click="validateAndDownload" class="download-button" color="primary">Download</c-button>
                </c-input>
            </div>
        </c-modal>
        <div class="container-sm mb-16">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div class="hero-content">
                    <h1 class="mt-0 mb-12 reveal-scale-down" data-reveal-delay="300">
                        Build better screenshots.
                    </h1>
                    <div class="container-xs">
                        <p class="m-0 mb-32 reveal-scale-down" data-reveal-delay="400">
                            Your days of snipping and snagging end here. Pixtel helps you <b>capture</b>, <b>edit</b>, and <b>share</b> anything on your screen in a few clicks.
                        </p>
                        <div class="reveal-scale-down" data-reveal-delay="500">
                            <c-button tag="a" color="primary" href="#plans" wide-mobile>View Plans</c-button>
                            <c-button id="download" aria-controls="email-modal" @click="resetInput(); emailModalActive = true" style="margin-left: calc(min(0.5rem,.5vw)); margin-top: calc(min(0.5rem,2vw));" color="secondary" wide-mobile>Download for Windows</c-button>
                        </div>
                    </div>
                </div>
                <div class="hero-figure filter-on-hover illustration-element-01 reveal-scale-down" data-reveal-delay="600">
                    <a
                        data-video="https://player.vimeo.com/video/702712089"
                        href="#"
                        aria-controls="video-modal"
                        @click.prevent="videoModalActive = true">
                        <c-image
                            class="has-shadow"
                            :src="require('@/assets/images/video-placeholder.png')"
                            alt="Video"
                            :width="896"
                            :height="502" />
                    </a>
                </div>
                <c-modal
                    id="video-modal"
                    :active.sync="videoModalActive"
                    video="https://player.vimeo.com/video/702712089"
                    video-tag="iframe" />
            </div>
        </div>
    </section>
</template>
<style>
.download-button:hover {
    background-color: #6970be !important;
}
.filter-on-hover > a > .has-shadow:hover {
    filter: brightness(0.9);
    transition: all 0.2s ease-in-out;
}
</style>
<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'
import CModal from '@/components/elements/Modal.vue'
import CInput from '@/components/elements/Input.vue'

import axios from 'axios'

export default {
  name: 'CHeroFull',
  mixins: [SectionProps],
  components: {
    CButton,
    CImage,
    CModal,
    CInput
  },
  data() {
    return {
      emailModalActive: false,
      videoModalActive: false,
      emailAddress: null,
      status: null,
      hint: ''
    }
  },
  methods: {
    onEnter() {
        this.validateAndDownload();
    },
    resetInput() {
        this.emailAddress = null;
        this.state = '';
        this.hint = '';
    },
    validateAndDownload() {
        const validateEmail = (email) => {
            return email
                .toLowerCase()
                .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };
        if (validateEmail(this.emailAddress)) {
            this.status = 'success'
            this.hint = 'Welcome to Pixtel. If you\'re on your computer, your download should start. Otherwise, we\'ll send you an email you can find later.'
            this.download();
        } else {
            this.status = 'error'
            this.hint = 'Are you sure this is a valid email address?'
        }
    },
    download() {
        var obj = {
            firstname: this.emailAddress,
            lastname: this.emailAddress,
            emailaddress: this.emailAddress,
            attr1: null,
            apikey: 'EFdsGyN1bYrAFSmaBUiK516qdrnOnOyn2Pdx4RK46haJalrTD14SV4W804i2YiLwFz57aBG+duoP/c3znU90Nw=='
        };

        axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] }).post('https://hooks.zapier.com/hooks/catch/9379157/bzc7qf8', { plan: 'trial', email: this.emailAddress });

        axios.get('https://ipapi.co/json/')
        .then(response => {
            obj.attr1 = JSON.stringify(response);
        })
        .catch(error => {
            //console.error(error);
        })
        .finally(() => {
            var jsonData = JSON.stringify(obj);
            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", "https://pixteldb.herokuapp.com/webservices/registermailinglist", true);
            xhttp.setRequestHeader("Content-type", "application/json");
            xhttp.send(jsonData);
            axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] }).post('https://hooks.zapier.com/hooks/catch/9379157/bzc7qf8/', obj);
            window.location='https://www.dropbox.com/s/4vkx6yb864ew3x5/Pixtel.msi?dl=1';
        })
    }
  }
}
</script>
